// store.js
import { createStore } from 'vuex';

// Create a new store instance.
const store = createStore({
    state() {
        const savedUser = sessionStorage.getItem('user');
        const user = savedUser ? JSON.parse(savedUser) : {
            id: null,
            nickname: null,
            grade: '',       // ✅ 'member' 또는 'tester'
            status: 'pending',     // ✅ 추가: 'pending', 'rejected', 'active', 'suspended', 'deleted'
            cash: 0,
            credit: 0,
            point: 0,
            account: '',           // ✅ bank -> account로 변경
            token: null,
            phone: '',
            preset: '',
            max_bet_h: 0,          // ✅ 추가 (max_betd -> max_bet_h)
            max_bet_l: 0           // ✅ 추가 (max_beto -> max_bet_l)
            // channel 삭제
        };
        
        const secret = null;
        
        // 기본 게임 세팅은 하드코딩하지 않는다 — games.json 로드 후 applyGameListDefaults 로 채운다.
        // (게임 타입 목록의 단일 출처 = games.json → 게임 추가 시 여기 수정 불필요)
        const savedGameState = sessionStorage.getItem('game_settings');
        const game_settings = savedGameState ? JSON.parse(savedGameState) : {};
        const savedServicePreset = sessionStorage.getItem('service_preset');
        const preset_settings = savedServicePreset ? JSON.parse(savedServicePreset) : {

        };
    
        const savedNoticeList = sessionStorage.getItem('notice_list');
        const savedPopupState = sessionStorage.getItem('popup_state');
        const savedReadNoticeList = user.id ? localStorage.getItem(user.id + '_read_notice') : null;
    
        return {
            user: user,
            msg_list: [],
            money_change_list: [],
            os: '',
            notice_list: savedNoticeList ? JSON.parse(savedNoticeList) : [],
            game_pop_state: savedPopupState ? JSON.parse(savedPopupState) : {
                game: false
            },
            notice_read_list: savedReadNoticeList ? JSON.parse(savedReadNoticeList) : [],
            notReadExist : false,
            game_setting : game_settings,
            preset_setting : preset_settings,
            secret : secret
        };
    },
    mutations: {
        setUser(state, value) {
            state.user = value;
            sessionStorage.setItem('user', JSON.stringify(state.user));
            console.log("user save test :");
            console.log(state.user);
        },
        setSecret(state, value) {
            // state.user.secret = value;
            // sessionStorage.setItem('account', JSON.stringify(state.user));
            state.secret = value;
            //console.log("secret:"+state.secret);
        }
        ,
        updateMoney(state, value) {
            state.user.cash = value.cash;
            state.user.credit = value.credit;
            state.user.point = value.point;
            sessionStorage.setItem('user', JSON.stringify(state.user));
        },
        popupStateChange(state, { key, value }) {
            //if (state.game_pop_state.hasOwnProperty(key)) {
            if (key in state.game_pop_state) {
                state.game_pop_state[key] = value;
            }
            sessionStorage.setItem('popup_state', JSON.stringify(state.game_pop_state));
        },
        removeUser(state) {
            state.user = {
                id: null,
                nickname: null,
                grade: '',
                status: 'pending',
                cash: 0,
                credit: 0,
                point: 0,
                account: '',
                token: null,
                phone: '',
                preset: '',
                max_bet_h: 0,
                max_bet_l: 0
            };
            state.secret = null;
            sessionStorage.removeItem('user');
        },
        setNoticeList(state, noticeList) {
            state.notice_list = noticeList;
            sessionStorage.setItem('notice_list', JSON.stringify(state.notice_list));
        },
        clearNoticeList(state) {
            state.notice_list = [];
            sessionStorage.removeItem('notice_list');
        },
        readNotice(state, id) {
            state.notice_read_list.push(id);
            localStorage.setItem(state.user.id + '_read_notice', JSON.stringify(state.notice_read_list))
        },
        setNoticeReadList(state, list) {
            state.notice_read_list = list;
            localStorage.setItem(state.user.id + '_read_notice', JSON.stringify(list));
        },
        setNoticeRead(state, { idx, isRead }) {
            const notice = state.notice_list.find(n => n.idx === idx);
            if (notice) {
                notice.isRead = isRead;
            }
        },
        setGameSettings(state, value) {
            // 업데이트 및 저장
            state.game_setting = value;
            sessionStorage.setItem('game_settings', JSON.stringify(value));
            console.log(sessionStorage.getItem('game_settings'));
        },
        // games.json 의 게임 type 목록으로 game_setting 기본값을 채운다(없는 키만 1로, 기존 값은 유지).
        // 로그인/live_game_setting 이 실제 값으로 덮어쓰기 전, 로그인 전 fallback 용.
        applyGameListDefaults(state, types) {
            if (!Array.isArray(types)) return;
            const gs = { ...state.game_setting };
            let changed = false;
            types.forEach(t => {
                const key = 'game' + t;
                if (gs[key] === undefined) { gs[key] = 1; changed = true; }
            });
            if (changed) state.game_setting = gs;
        },
        setServicePreset(state, value) {
            if (value != null)
            {
                value.forEach(element => {
                    let newKey = `${element.preset_id}`;
                    state.preset_setting[newKey] = element;
                    delete state.preset_setting[newKey].preset_id;
                });
                
                sessionStorage.setItem('service_preset', JSON.stringify(state.preset_setting));
                console.log(state.preset_setting);
            }
        }
    },
    getters: {
        getUser(state) {
            return state.user;
        },
        getNoticeList(state) {
            return state.notice_list;
        },
        getTrueKeys(state) {
            return Object.keys(state.game_pop_state).filter(key => state.game_pop_state[key] === true);
        }
    }
});

export default store;
